import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a64e43b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-screen h-screen" }
const _hoisted_2 = { class: "h-screen flex items-center justify-center" }
const _hoisted_3 = { class: "projectsModal fixed mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-between h-full"
}
const _hoisted_5 = { class: "monitorHolder h-full relative" }
const _hoisted_6 = { class: "w-full h-full flex justify-center items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "rightSide" }
const _hoisted_9 = { class: "role font-bold" }
const _hoisted_10 = { class: "setting font-medium" }
const _hoisted_11 = { class: "flex justify-start flex-wrap" }
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "overview font-bold mt-6" }, " OVERVIEW ", -1))
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 0,
  class: "skills font-bold mt-6"
}
const _hoisted_16 = { class: "featuresBox font-normal" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tools font-bold mt-6" }, " TOOLS USED ", -1))
const _hoisted_19 = { class: "toolBox font-normal pb-2" }
const _hoisted_20 = {
  key: 1,
  class: "h-full"
}
const _hoisted_21 = { class: "monitorHolder w-full relative" }
const _hoisted_22 = { class: "w-full h-full flex justify-center items-center" }
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { class: "back h-full w-full absolute object-cover top-0 left-0" }, null, -1))
const _hoisted_25 = { class: "rightSide h-full relative" }
const _hoisted_26 = { class: "role font-bold" }
const _hoisted_27 = { class: "setting font-medium" }
const _hoisted_28 = { class: "flex justify-start flex-wrap" }
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "overview font-bold mt-6" }, " OVERVIEW ", -1))
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 0,
  class: "skills font-bold mt-6"
}
const _hoisted_33 = { class: "featuresBox font-normal" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tools font-bold mt-6" }, " TOOLS USED ", -1))
const _hoisted_36 = { class: "toolBox font-normal pb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalMiniBox = _resolveComponent("ModalMiniBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
      class: "shadow bg-black w-screen h-screen z-50 absolute left-0 top-0 opacity-90"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.screen == 'computer')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
                  class: "exit font-light absolute top-6 right-6"
                }, " x "),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      class: "monitor",
                      src: _ctx.info.screen,
                      style: _normalizeStyle({ width: _ctx.monitorWidth })
                    }, null, 12, _hoisted_7)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.info.title), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.info.time), 1),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.links, (link) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("a", {
                          href: link.url,
                          target: "_blank",
                          class: "btn link font-medium text-black flex justify-center items-center"
                        }, _toDisplayString(link.title), 9, _hoisted_12)
                      ]))
                    }), 256))
                  ]),
                  _hoisted_13,
                  _createElementVNode("p", {
                    class: "desc font-normal",
                    innerHTML: _ctx.info.description
                  }, null, 8, _hoisted_14),
                  (_ctx.info.features.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, " FEATURES "))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.features, (feature) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createVNode(_component_ModalMiniBox, {
                          info: feature,
                          type: "featuresBox"
                        }, null, 8, ["info"])
                      ]))
                    }), 256))
                  ]),
                  (_ctx.info.tools)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("p", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.tools, (tool) => {
                            return (_openBlock(), _createElementBlock("div", null, [
                              _createVNode(_component_ModalMiniBox, {
                                info: tool,
                                type: "toolsBox"
                              }, null, 8, ["info"])
                            ]))
                          }), 256))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("img", {
                      class: "monitor",
                      src: _ctx.info.screen,
                      style: _normalizeStyle({ width: _ctx.monitorWidth, maxWidth: _ctx.monitorMaxWidth })
                    }, null, 12, _hoisted_23)
                  ]),
                  _hoisted_24
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("p", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
                    class: "exit font-light absolute top-4 right-3"
                  }, " x "),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.info.title), 1),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.info.time), 1),
                  _createElementVNode("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.links, (link) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("a", {
                          href: link.url,
                          target: "_blank",
                          class: "btn link font-medium text-black flex justify-center items-center"
                        }, _toDisplayString(link.title), 9, _hoisted_29)
                      ]))
                    }), 256))
                  ]),
                  _hoisted_30,
                  _createElementVNode("p", {
                    class: "desc font-normal",
                    innerHTML: _ctx.info.description
                  }, null, 8, _hoisted_31),
                  (_ctx.info.features.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_32, " FEATURES "))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.features, (feature) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createVNode(_component_ModalMiniBox, {
                          info: feature,
                          type: "featuresBox"
                        }, null, 8, ["info"])
                      ]))
                    }), 256))
                  ]),
                  (_ctx.info.tools)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("p", _hoisted_36, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.tools, (tool) => {
                            return (_openBlock(), _createElementBlock("div", null, [
                              _createVNode(_component_ModalMiniBox, {
                                info: tool,
                                type: "toolsBox"
                              }, null, 8, ["info"])
                            ]))
                          }), 256))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ])
      ])
    ])
  ], 64))
}